<template>
  <div class="big-tag-add-overlay">
    <MetaTagAdd
      v-if="props.hasTags || true"
      @add="(tag) => emit('add', tag)"
      class="tag-add"
    >
      <template #after="{ submitTag }">
        <div class="buttons">
          <a @click="emit('close')" class="close">
            <SvgSymbol
              symbol="close"
              :color="textColor"
            />
          </a>
          <a @click="submitTag()" class="save">
            <SvgSymbol symbol="save" :color="textColor"/>
          </a>
        </div>
      </template>
    </MetaTagAdd>
    <div v-else>Tags not yet loaded.</div>
  </div>
</template>

<script setup lang="ts">
import SvgSymbol from "@/components/Svg/SvgSymbol.vue";
import { defineEmits, defineProps } from 'vue'
import MetaTagAdd from "@/components/meta/MetaTagAdd.vue";
import { useThemeColor } from "@/composables/useThemeColor";

const emit = defineEmits<{
  (e: "close"): void;
  (e: "add", tag: string): void;
}>();
const props = defineProps<{ hasTags: boolean }>();
const textColor = useThemeColor();
</script>

<style scoped lang="scss">
.big-tag-add-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1em;
    width: 100%;
    max-width: 40em;
    margin-bottom: 1em;
    .close {
      svg {
        flex-shrink: 2;
        flex-grow: 0;
      }
    }
    .close, .save {
      flex-grow: 0;
      flex-shrink: 0;
    }
    ::v-deep(svg)
    {
      width: 4em;
      height: 4em;
      font-size: 1em;
    }
  }
  .tag-add {
    flex-shrink: 0;
    flex-grow: 2;
    flex-direction: column-reverse;

    ::v-deep(.autocomplete) {
      input.autocomplete-input {
        font-size: calc( max(6vmin, 4vh, 4vw) );
      }
      ul.autocomplete-results {
        font-size: calc( max(6vmin, 4vh, 4vw) );
        max-height: initial;
        flex-grow: 2;
      }
    }
  }
}
</style>
